/* VÆLD — scroll progress line. Scales a top hairline with page scroll. */

(function () {
  'use strict';

  var bar = document.querySelector('[data-progress]');
  if (!bar) return;

  var ticking = false;

  function update() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var pct = max > 0 ? (window.scrollY / max) : 0;
    bar.style.transform = 'scaleX(' + pct.toFixed(4) + ')';
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  window.addEventListener('resize', update);
  update();
})();
